import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import Tooltip, {TooltipProps} from "@mui/material/Tooltip";

interface TitleWithInfoTooltipProps {
    title: string;
    tooltip?: string;
    className?: string;
    iconClassName?: string;
    tooltipPlacement?: TooltipProps['placement'];
}

const TitleWithInfoTooltip = ({
                                  title,
                                  tooltip,
                                  className = '',
                                  iconClassName = '',
                                  tooltipPlacement = 'top'
                              }: TitleWithInfoTooltipProps) => {
    return (
        <span className={`inline-flex items-center gap-2 ${className}`}>
            <span>{title}</span>
            {tooltip ?
                <Tooltip title={<span className="w-full inline-block text-center">{tooltip}</span>} placement={tooltipPlacement} enterTouchDelay={0} leaveTouchDelay={3000}>
                    <span
                        tabIndex={0}
                        aria-label={tooltip}
                        className="outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded-full cursor-help inline-flex"
                    >
                        <FontAwesomeIcon
                            icon={solid('circle-info')}
                            className={`text-blue-gray-400 dark:text-blue-gray-200 text-sm ${iconClassName}`}/>
                    </span>
                </Tooltip> : null}
        </span>
    );
};

export default TitleWithInfoTooltip;
